import api from './api';

export const mercadoPagoService = {
  async getConfig() {
    const response = await api.get('/mercadopago/config');
    return response.data;
  },

  async saveConfig(payload) {
    const response = await api.put('/mercadopago/config', payload);
    return response.data;
  },

  async getPublicKey() {
    const response = await api.get('/mercadopago/public-key');
    return response.data;
  }
};
